"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (Element) {
    var parent = Element.parentNode;
    if (parent) {
        parent.removeChild(Element);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/kompo-util/lib/remove.js
// module id = 24
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11